<div class="alert-config-fields">
  <div class="field-grid" [formGroup]="form">
    <div class="setting-card setting-card--span-all">
      <div class="notify-window-row">
        <mat-form-field appearance="outline" class="notify-window-row__field" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Alert window start</mat-label>
          <input matInput type="time" required formControlName="notifyWindowStart" />
          <mat-hint>Earliest time to send alerts</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" class="notify-window-row__field" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Alert window end</mat-label>
          <input matInput type="time" required formControlName="notifyWindowEnd" />
          <mat-hint>Latest time to start new sends</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline" class="notify-window-row__field" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Time zone</mat-label>
          <mat-select formControlName="notifyWindowTimeZone">
            @for (tz of timeZoneOptions; track tz.id) {
              <mat-option [value]="tz.id">{{ tz.label }}</mat-option>
            }
          </mat-select>
          <mat-hint>Used for schedule and window</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="setting-card setting-card--span-all">
      <div
        class="retry-settings-row"
        [class.retry-settings-row--with-target]="showDayTargetTime()"
      >
        <mat-form-field appearance="outline" class="retry-settings-row__attempts" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Retry attempts</mat-label>
          <input
            matInput
            type="number"
            required
            min="1"
            [max]="retryAttemptsMax"
            formControlName="retryAttempts"
          />
          @if (form.controls.retryAttempts.hasError('required')) {
            <mat-error>Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="retry-settings-row__interval" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Interval between retries</mat-label>
          <input
            matInput
            type="number"
            required
            [min]="intervalMin()"
            step="1"
            formControlName="retryInterval"
            [placeholder]="intervalPlaceholder()"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="retry-settings-row__unit" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Unit</mat-label>
          <mat-select formControlName="retryIntervalUnit">
            @for (unit of intervalUnits; track unit) {
              <mat-option [value]="unit">{{ intervalUnitLabel(unit) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (showDayTargetTime()) {
          <mat-form-field appearance="outline" class="retry-settings-row__target-time" subscriptSizing="dynamic" floatLabel="always">
            <mat-label>Target time of day</mat-label>
            <input matInput type="time" required formControlName="targetTime" />
          </mat-form-field>
        }
      </div>
    </div>
  </div>

  @if (showCampaignSchedule && cycleSlots) {
    <div class="field-grid campaign-cycle">
      <div class="setting-card setting-card--span-all campaign-cycle">
        @if (customScheduleControl) {
          <mat-checkbox class="campaign-cycle__custom" [formControl]="customScheduleControl">
            Custom
          </mat-checkbox>
        }
        @for (slot of cycleSlots.controls; track $index) {
          <div class="campaign-cycle__row" [formGroup]="$any(slot)">
            <span class="campaign-cycle__attempt">Attempt {{ $index + 1 }}</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
              <mat-label>Date</mat-label>
              <input matInput type="date" formControlName="date" />
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
              <mat-label>Time</mat-label>
              <input matInput type="time" formControlName="time" />
            </mat-form-field>
          </div>
        }
      </div>
    </div>
  }

  <div class="field-grid" [formGroup]="form">
    <div class="setting-card setting-card--span-all">
      <div class="sms-toolbar">
        <a class="use-default" href="#" (click)="$event.preventDefault(); onUseDefault()">Use default</a>
      </div>
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic" floatLabel="always">
        <mat-label>Text message</mat-label>
        <textarea matInput rows="4" required formControlName="smsBody" [maxlength]="smsMax"></textarea>
        <mat-hint align="end">{{ smsLength() }} / {{ smsMax }}</mat-hint>
        @if (form.controls.smsBody.hasError('required')) {
          <mat-error>Required</mat-error>
        } @else if (form.controls.smsBody.hasError('smsTokens')) {
          <mat-error>{{ smsTokenError() }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="setting-card setting-card--span-all setting-card--press0">
      <p class="token-help">
        {{ smsPlaceholderHelp }}
        @for (label of smsTokenLabels; track label) {
          <code>{{ label }}</code>
        }
      </p>
      <div class="press0-row">
        <mat-checkbox formControlName="pressZeroToConnect">
          Include “press 0 to connect now” in the alert
        </mat-checkbox>
        <mat-form-field appearance="outline" class="press0-row__channel" subscriptSizing="dynamic" floatLabel="always">
          <mat-label>Delivery</mat-label>
          <mat-select formControlName="notifyChannel">
            @for (channel of notifyChannels; track channel) {
              <mat-option [value]="channel">{{ notifyChannelLabel(channel) }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="setting-card">
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic" floatLabel="always">
        <mat-label>Link title</mat-label>
        <input matInput type="text" formControlName="urlTitle" placeholder="e.g. Patient portal" />
      </mat-form-field>
    </div>
    <div class="setting-card">
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic" floatLabel="always">
        <mat-label>Link URL</mat-label>
        <input matInput type="url" formControlName="urlHyperlink" placeholder="https://" />
      </mat-form-field>
    </div>
  </div>
</div>
